import * as React from "react";
import { Button, Modal, Radio } from "semantic-ui-react";
import { Player, PlayerCardCreateRequestBody } from "../../../services/bedrock";
import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";

interface AddPlayerCardWarningModalProps {
  open: boolean;
  playersWithoutAccess: Player[];
  onClose: (confirm: boolean) => void;
}

const AddPlayerCardWarningModal: React.FC<AddPlayerCardWarningModalProps> = ({
  open,
  playersWithoutAccess,
  onClose,
}) => {
  const [playerCardAccess, setPlayerCardAccess] = useState<"No" | "Yes" | "YesGlobally">("Yes");

  const { setValue } = useFormContext<PlayerCardCreateRequestBody>();

  useEffect(() => {
    setValue("grantPlayerCardAccess", playerCardAccess === "Yes");
    setValue("grantPlayerCardAccessGlobally", playerCardAccess === "YesGlobally");
  }, [open, playerCardAccess, setValue]);

  return (
    <Modal open={open} size="tiny" className="addPlayerCardWarningModal">
      <Modal.Header>Uh oh!</Modal.Header>
      <Modal.Content>
        <div>
          It looks like the following Players don't have Player Card access:
          <ul>
            {playersWithoutAccess.map(p => (
              <li key={p.id}>{p.fullName}</li>
            ))}
          </ul>
          Unless you grant them access, their Player Cards will not be publicly available.
        </div>
        <strong>Would you like to turn that setting on?</strong>
        <div className="grantPlayerCardAccessRadioGroup">
          <Radio
            label="Yes"
            name="grantPlayerCardAccess"
            onChange={() => setPlayerCardAccess("Yes")}
            checked={playerCardAccess === "Yes"}
          />
          <Radio
            label="No (grant access later)"
            name="grantPlayerCardAccess"
            onChange={() => setPlayerCardAccess("No")}
            checked={playerCardAccess === "No"}
          />
          <Radio
            label="Turn on for all Players"
            name="grantPlayerCardAccess"
            onChange={() => setPlayerCardAccess("YesGlobally")}
            checked={playerCardAccess === "YesGlobally"}
          />
        </div>
      </Modal.Content>
      <Modal.Actions>
        <Button secondary content="Cancel" onClick={() => onClose(false)} />
        <div className="grow" />
        <Button primary content="Continue" onClick={() => onClose(true)} />
      </Modal.Actions>
    </Modal>
  );
};
export default AddPlayerCardWarningModal;
